/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshTokenCommand
 */
export interface RefreshTokenCommand {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenCommand
     */
    refreshToken: string;
}

export function RefreshTokenCommandFromJSON(json: any): RefreshTokenCommand {
    return RefreshTokenCommandFromJSONTyped(json, false);
}

export function RefreshTokenCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshTokenCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'refreshToken': json['refreshToken'],
    };
}

export function RefreshTokenCommandToJSON(value?: RefreshTokenCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'refreshToken': value.refreshToken,
    };
}

